import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

const Video = ({ blok }) => (
  <SbEditable content={blok}>
    <div className="video">
      <iframe
        title={blok.title}
        className="lazyload video__player"
        data-src={blok.url}
        frameBorder="0"
      />
    </div>
  </SbEditable>
)

Video.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
}

export default Video
